import React from 'react';

const GmgLevelDiagram = ({
  // highlighted gmg level
  gmgLevel = 5,

  // text labels
  labelGmgLevel1 = 'GMG Level 1',
  labelGmgLevel2 = 'GMG Level 2',
  labelGmgLevel3 = 'GMG Level 3',
  labelGmgLevel4 = 'GMG Level 4',
  labelGmgLevel5 = 'GMG Level 5',

  labelData = 'Data',
  labelAnalytics = 'Analytics',
  labelHumanInput = 'Human Input',
  labelDecision = 'Decision',
  labelAction = 'Action',

  labelDescriptive = 'Descriptive',
  labelWhatHappened = 'What happened?',
  labelDiagnostic = 'Diagnostic',
  labelWhyDidItHappen = 'Why did it happen?',
  labelPredictive = 'Predictive',
  labelWhatWillHappen = 'What will happen?',
  labelPrescriptive = 'Prescriptive',
  labelWhatShouldIDo = 'What should I do?',
  labelDecisionSupport = 'Decision Support',
  labelDecisionAutomation = 'Decision Automation',

  // gmg highlight color
  gmgLevelFill = '#D12200',
  gmgFillOpacity = '0.15',
  gmgLevelStroke = '#D12200',
  gmgLevelStrokeWidth = 4,

  // styling props
  style = {},
  className = '',

  // image proportions
  viewBox = '0 0 570 280',

  // element fills
  actionFill = '#FC9604',
  decisionFill = '#2E6705',
  humanInputFill = '#9FCF09',
  analyticFill = '#044E9C',
  dataFill = '#6C96D4',

  // typographic elements
  fontFamily = 'Roboto, Franklin Gothic Medium, Tahoma, sans-serif',
  fontBold = '500',
  fontLight = '300',
  fontSizeLarge = '11.5px',
  fontSizeSmall = '9px',
  fontColorLight = '#FFFFFF',
  fontColorDark = '#000000'
}) => (
  <svg
    version="1.0"
    id="gmg_level_diagram"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className={`svg-icon ${className || ''}`}
    style={style}
    viewBox={viewBox}
    fontFamily={fontFamily}>
    <rect id="action" x="491" y="30.3" fill={actionFill} width="79" height="239.7" />
    <rect id="decision" x="412" y="30.3" fill={decisionFill} width="79" height="239.7" />

    <polygon
      id="humaninput_level_3"
      fill={humanInputFill}
      points="412,171.5 175,171.5 175,128.7 412,128.7 429,150.1 "
    />
    <polygon
      id="humaninput_level_2"
      fill={humanInputFill}
      points="412,122.3 175,122.3 175,79.5 412,79.5 429,100.9 "
    />
    <polygon
      id="humaninput_level_1"
      fill={humanInputFill}
      points="412,73 175,73 175,30.2 412,30.2 429,51.6 "
    />

    <rect
      id="analytic_level_4and5linked"
      x="175"
      y="178"
      fill={analyticFill}
      width="175"
      height="92"
    />
    <polygon
      id="analytic_level_5"
      fill={analyticFill}
      points="491,270 175,270 175,227.2 491,227.2 508,248.6 "
    />
    <polygon
      id="analytic_level_4"
      fill={analyticFill}
      points="412,220.8 175,220.8 175,178 412,178 429,199.4 "
    />
    <polygon
      id="analytic_level_3"
      fill={analyticFill}
      points="373,171.5 175,171.5 175,128.7 373,128.7 390,150.1 "
    />
    <polygon
      id="analytic_level_2"
      fill={analyticFill}
      points="325,122.3 175,122.3 175,79.5 325,79.5 342,100.9 "
    />
    <polygon
      id="analytic_level_1"
      fill={analyticFill}
      points="277,73 175,73 175,30.2 277,30.2 294,51.6 "
    />

    <rect id="data" x="108" y="30.3" fill={dataFill} width="68" height="239.7" />

    <g id="diagram_labels">
      <g id="label_action">
        <text
          textAnchor="middle"
          transform="matrix(1 0 0 1 530.0857 153.663)"
          fill={fontColorDark}
          fontWeight={fontBold}
          fontSize={fontSizeLarge}>
          {labelAction}
        </text>
      </g>
      <g id="label_decision">
        <text
          transform="matrix(1 0 0 1 436.3055 153.663)"
          fill={fontColorLight}
          fontWeight={fontBold}
          fontSize={fontSizeLarge}>
          {labelDecision}
        </text>
      </g>
      <g id="label_data">
        <text
          textAnchor="middle"
          transform="matrix(1 0 0 1 142 153.663)"
          fill={fontColorLight}
          fontWeight={fontBold}
          fontSize={fontSizeLarge}>
          {labelData}
        </text>
      </g>
      <text
        id="label_descriptive"
        transform="matrix(1 0 0 1 190 48.7169)"
        fill={fontColorLight}
        fontWeight={fontBold}
        fontSize={fontSizeLarge}>
        {labelDescriptive}
      </text>
      <text
        id="label_diagnostic"
        transform="matrix(1 0 0 1 190 97.7169)"
        fill={fontColorLight}
        fontWeight={fontBold}
        fontSize={fontSizeLarge}>
        {labelDiagnostic}
      </text>
      <text
        id="label_redictive"
        transform="matrix(1 0 0 1 190 145.7169)"
        fill={fontColorLight}
        fontWeight={fontBold}
        fontSize={fontSizeLarge}>
        {labelPredictive}
      </text>
      <text
        id="label_prescriptive"
        transform="matrix(1 0 0 1 190 194.7169)"
        fill={fontColorLight}
        fontWeight={fontBold}
        fontSize={fontSizeLarge}>
        {labelPrescriptive}
      </text>
      <g id="label_decision_support">
        <text
          transform="matrix(1 0 0 1 330.2332 201.7169)"
          fill={fontColorLight}
          fontWeight={fontLight}
          fontSize={fontSizeSmall}>
          {labelDecisionSupport}
        </text>
      </g>
      <g id="label_decision_automation">
        <text
          transform="matrix(1 0 0 1 330.2332 252.7169)"
          fill={fontColorLight}
          fontWeight={fontLight}
          fontSize={fontSizeSmall}>
          {labelDecisionAutomation}
        </text>
      </g>
      <g id="label_what_should_i_do">
        <text
          transform="matrix(1 0 0 1 190 207.7169)"
          fill={fontColorLight}
          fontWeight={fontLight}
          fontSize={fontSizeSmall}>
          {labelWhatShouldIDo}
        </text>
      </g>
      <g id="label_what_will_happen">
        <text
          transform="matrix(1 0 0 1 190 157.7169)"
          fill={fontColorLight}
          fontWeight={fontLight}
          fontSize={fontSizeSmall}>
          {labelWhatWillHappen}
        </text>
      </g>
      <g id="label_why_did_it_happen">
        <text
          transform="matrix(1 0 0 1 190 110.7169)"
          fill={fontColorLight}
          fontWeight={fontLight}
          fontSize={fontSizeSmall}>
          {labelWhyDidItHappen}
        </text>
      </g>
      <g id="label_what_happened">
        <text
          transform="matrix(1 0 0 1 190 60.7169)"
          fill={fontColorLight}
          fontWeight={fontLight}
          fontSize={fontSizeSmall}>
          {labelWhatHappened}
        </text>
      </g>
      <g id="label_analytics">
        <text
          transform="matrix(1 0 0 1 190 19.7169)"
          fill={fontColorDark}
          fontWeight={fontBold}
          fontSize={fontSizeLarge}>
          {labelAnalytics}
        </text>
      </g>
      <g id="label_human_input">
        <text
          textAnchor="middle"
          transform="matrix(1 0 0 1 348.2332 19.7169)"
          fill={fontColorDark}
          fontWeight={fontBold}
          fontSize={fontSizeLarge}>
          {labelHumanInput}
        </text>
      </g>
    </g>

    <g id="gmg_level_5">
      {gmgLevel === 5 && (
        <g id="outline_gmg_level_5">
          <rect
            x="2"
            y="227"
            fill={gmgLevelFill}
            fillOpacity={gmgFillOpacity}
            stroke={gmgLevelStroke}
            strokeWidth={gmgLevelStrokeWidth}
            vectorEffect="non-scaling-stroke"
            width="566"
            height="43.5"
          />
        </g>
      )}
      <g id="label_gmg_level_5">
        <text
          textAnchor="middle"
          transform="matrix(1 0 0 1 52 252.2568)"
          fontWeight={fontBold}
          fontSize={fontSizeLarge}>
          {labelGmgLevel5}
        </text>
      </g>
    </g>

    <g id="gmg_level_4">
      {gmgLevel === 4 && (
        <g id="outline_gmg_level_4">
          <rect
            x="2"
            y="178"
            fill={gmgLevelFill}
            fillOpacity={gmgFillOpacity}
            stroke={gmgLevelStroke}
            strokeWidth={gmgLevelStrokeWidth}
            vectorEffect="non-scaling-stroke"
            width="566"
            height="43.5"
          />
        </g>
      )}
      <g id="label_gmg_level_4">
        <text
          textAnchor="middle"
          transform="matrix(1 0 0 1 52 203.2568)"
          fontWeight={fontBold}
          fontSize={fontSizeLarge}>
          {labelGmgLevel4}
        </text>
      </g>
    </g>

    <g id="gmg_level_3">
      {gmgLevel === 3 && (
        <g id="outline_gmg_level_3">
          <rect
            x="2"
            y="128"
            fill={gmgLevelFill}
            fillOpacity={gmgFillOpacity}
            stroke={gmgLevelStroke}
            strokeWidth={gmgLevelStrokeWidth}
            vectorEffect="non-scaling-stroke"
            width="566"
            height="43.5"
          />
        </g>
      )}
      <g id="label_gmg_level_3">
        <text
          textAnchor="middle"
          transform="matrix(1 0 0 1 52 153.2568)"
          fontWeight={fontBold}
          fontSize={fontSizeLarge}>
          {labelGmgLevel3}
        </text>
      </g>
    </g>

    <g id="gmg_level_2">
      {gmgLevel === 2 && (
        <g id="outline_gmg_level_2">
          <rect
            x="2"
            y="79"
            fill={gmgLevelFill}
            fillOpacity={gmgFillOpacity}
            stroke={gmgLevelStroke}
            strokeWidth={gmgLevelStrokeWidth}
            vectorEffect="non-scaling-stroke"
            width="566"
            height="43.5"
          />
        </g>
      )}
      <g id="label_gmg_level_2">
        <text
          textAnchor="middle"
          transform="matrix(1 0 0 1 52 104.2568)"
          fontWeight={fontBold}
          fontSize={fontSizeLarge}>
          {labelGmgLevel2}
        </text>
      </g>
    </g>

    <g id="gmg_level_1">
      {gmgLevel === 1 && (
        <g id="outline_gmg_level_1">
          <rect
            x="2"
            y="30"
            fill={gmgLevelFill}
            fillOpacity={gmgFillOpacity}
            stroke={gmgLevelStroke}
            strokeWidth={gmgLevelStrokeWidth}
            vectorEffect="non-scaling-stroke"
            width="566"
            height="43.5"
          />
        </g>
      )}
      <g id="label_gmg_level_1">
        <text
          textAnchor="middle"
          transform="matrix(1 0 0 1 52 55.2568)"
          fontWeight={fontBold}
          fontSize={fontSizeLarge}>
          {labelGmgLevel1}
        </text>
      </g>
    </g>
  </svg>
);

export default GmgLevelDiagram;
